export default "/assets/site/images/Rectangle 13.png?638dcb3b0bf64a237d83317e797eb387";